// Components
import { CheckInput, TextInput } from '@octano/global-ui';
// Hooks
import { useContext } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';
import { TranslationsKeys } from '../../../../../../locales/translations';

import { formatToOnlyPositiveScaledIntegers } from '../../../../../../utils/currency';
// Utils
import { InstallmentSettingsContext } from '../context';
// Types
import { InstallmentSettingsForm } from '../types';

const prefix = 'tariffDownPayment';

// Render
export default function TariffDownPaymentSection() {
  const { t } = useTranslation(TranslationsKeys.CONFIGURATION_FINANTIAL);

  const installmentSettingsContext = useContext(InstallmentSettingsContext);

  const { control, watch } = useFormContext<InstallmentSettingsForm>();

  const [hasTariffDownPayment] = watch(['hasTariffDownPayment']);

  return (
    <Row className="mt-4">
      <Col xs={12}>
        <h2 className="text-primary fs-16 fw-600 text-uppercase">
          {t(`${prefix}.title`)}
        </h2>
      </Col>
      <Col sm={12} md={6}>
        <CheckInput
          name="hasTariffDownPayment"
          label={t(`${prefix}.inputs.hasTariffDownPayment`)}
          control={control}
          disabled={installmentSettingsContext.disabled}
        />
        {!!hasTariffDownPayment && (
          <TextInput
            control={control}
            name="maxTariffDownPaymentRate"
            label={t(`${prefix}.inputs.maxTariffDownPaymentRate`)}
            disabled={installmentSettingsContext.disabled}
            formatter={formatToOnlyPositiveScaledIntegers}
          />
        )}
      </Col>
    </Row>
  );
}
